import { Grid, Typography } from '@mui/material';
import React from 'react';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';
import { DepartmentMenu } from '../Department/DepartmentMenu';
import ActionButton from '../../../components/common/ActionButtonAndMenu/ActionButton';

const DepartmentData = ({ department, id }) => {
    const navigate = useNavigate();
    const details = {
        Name: department?.name ?? '',
        Status: department?.status ?? '',
    };

    return (
        <Grid container spacing={4}>
            <Grid item md={12} xs={12}>
                <Grid
                    container
                    spacing={3}
                    sx={{
                        mb: 5,
                    }}
                >
                    <Grid item xs={12}>
                        <Box sx={styles.titleWrapper}>
                            <Typography color="neutral.600" variant="subtitle2">
                                Department Details
                            </Typography>
                            <DepartmentMenu
                                Component={ActionButton}
                                row={{
                                    id,
                                    ...department,
                                }}
                                handleAction={() => navigate('/settings/departments')}
                            />
                        </Box>
                    </Grid>
                    {Object.keys(details).map((key) => (
                        <Grid
                            key={key}
                            item
                            xs={4}
                            sx={{
                                pt: '32px !important',
                            }}
                        >
                            <Typography color="neutral.600" variant="body2">
                                {key}
                            </Typography>
                            {typeof details[key] === 'string' || !details[key] ? (
                                <Typography
                                    color="neutral.700"
                                    variant="h6"
                                    sx={{
                                        pt: 2,
                                    }}
                                >
                                    {details[key] || ''}
                                </Typography>
                            ) : (
                                details[key]
                            )}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DepartmentData;
